<template>
  <div :class="detailLayout ? 'ad-record-group-panel' : 'row mx-0 ad-record-group-panel'">
    <TipsAndPrivewDilog
      :id="host.getPreviewPopupId(group.primaryAd)"
      :Type="1"
      :scrollToNums="host.getPreviewScrollToNums(group.primaryAd)"
      :Url="host.getPreviewDialogUrl(group.primaryAd)"
      :IsShowExternalSolt="true"
      :DilogTitle="host.getPreviewDialogTitle(group.primaryAd)"
    />
    <div
      class="d-flex flex-row Ad-Top adPageCard"
      :class="{
        'adPageCard-Wh': host.isFullWidthPageCard(tab.type),
        'adPageCard--detail': detailLayout,
        'adPageCard--logo-wide': isLogoExhibitorWidePreview,
      }"
      :style="host.getPageCardRowStyle(tab.type)"
    >
      <div class="adDetailCardWrapper">
        <slot name="detail-header" />
        <adEffectiveDateComponentNews
          :data="host.toEffectiveDateData(group.primaryAd)"
          :PagesTitle="host.getPagesTitle(group.primaryAd)"
          :detail-layout="detailLayout"
        >
          <template v-if="host.needProductSelect(group.primaryAd)" v-slot:ProductSelect>
            <div class="Ad-Top">
              <template v-if="tab.type === 'videoAd'">
                <div class="AdBlockTitle">{{ $t('lbl_EMPBE_VideoAd_SelectVideo') }}</div>
              </template>
              <template v-else>
                <div class="AdBlockTitle">{{ $t('lbl_EMPBE_Ad_Product_Display') }}</div>
                <span class="AdBlockTitle_p">{{ $t('lbl_EMPBE_Ad_Product_Display_P_FirstHalf') }}</span>
                <router-link :to="{ path: '/productInfoCenter/default' }" custom v-slot="{ navigate }">
                  <a href="javascript:void(0)" @click="navigate($event)" class="AdBlockTitle_p AdBlockTitle_p_CompanyInfo">
                    {{ $t('lbl_EMPBE_ProductInfo') }}
                  </a>
                </router-link>
                <span class="AdBlockTitle_p">{{ $t('lbl_EMPBE_Ad_Product_Display_P_RemainingHalf') }}</span>
              </template>
            </div>
            <productSelection
              class="Ad-Top-Product"
              :value="group.primaryAd._selectedProduct"
              :id="`${tab.type}_${group.primaryAd.adDetailId}`"
              :valueId="host.fromAdmin ? group.primaryAd.productId : group.primaryAd.temp_ProductId"
              :supplierId="host.companyid"
              :usagetype="tab.type === 'videoAd' ? 'ExhibitVideo' : 'photo'"
              :isNotblurryType="tab.type === 'videoAd'"
              :imgUsageType="tab.type === 'videoAd' ? 'ExhibitVideo_Cover' : ''"
              :HotAppIds="host.HotAppIds"
              :isHotApp="['starAd', 'priorityAd'].includes(tab.type)"
              :placeOtherText="tab.type === 'videoAd' ? $t('lbl_EMPBE_VideoAd_SelectVideo') : $t('lbl_EMPBE_Ad_Product_Display_Placeother')"
              :disabled="host.GetPowerStrus"
              :refreshToken="tab.refreshToken"
              @input="(val) => host.onProductSelected(group.primaryAd, val)"
            />
          </template>
        </adEffectiveDateComponentNews>

        <adDisplayPageComponentNews
          v-if="group.primaryAd.isSelectData && !host.adRecordsLoading"
          :id="`${tab.type}_${group.primaryAd.adDetailId}`"
          :HotAppIds="host.HotAppIds"
          :prodCats="host.prodCats"
          :selectProd="group.primaryAd._selectedProduct"
          :refreshToken="tab.refreshToken"
          :AdOptionsData="host.getAdOptionsData(group.primaryAd, tab.type)"
          :IsProductSelect="host.needProductSelect(group.primaryAd)"
          :data="host.getSearchRecords(group.primaryAd.adDetailId)"
          :hideTitle="host.needProductSelect(group.primaryAd)"
          :AdsDisplayOption="host.AdsDisplayOption"
          :isHotApp="['starAd', 'priorityAd'].includes(tab.type)"
          :isPriority="tab.type === 'priorityAd'"
          :adDetailId="group.primaryAd.adDetailId"
          :isReadonly="host.GetPowerStrus"
          :isSearchResult="group.primaryAd.isSelectData && !group.primaryAd.isSelectProduct"
          :checkNull="host.CheckVals"
          :display-preview-url="nonBannerSlotPreviewUrl"
          @noAllowSubmit="host.ChangeSubmitStrus"
          @noticeErrorSubmit="host.ChangeErrorSubmitStrus"
        />

        <div v-if="tab.type === 'logoAd'" class="Ad-Top AdlogoTop">
          <div class="logoImg">
            <img class="Ad-logoImg" :src="host.CompanyInfoPhoto" alt="" />
          </div>
          <div class="AdlogoTop-Msg">
            <div class="AdDataName">{{ $t('lbl_EMPBE_LogoAd_CompanyLogoAdvertisement') }}</div>
            <div class="AdName_p">
              <span>
                {{ $t('lbl_EMPBE_LogoAd_CompanyLogoAdvertisement_Tips') }}
                <router-link :to="{ name: 'Report', query: { TabIndex: 2 } }" custom v-slot="{ navigate }">
                  <a
                    href="javascript:void(0)"
                    @click="navigate($event)"
                    class="pl-0"
                    v-bind:t_label="host.adInfoCenterTLabel('Detail', 'btnToCompanyInfoCenter', '', group.primaryAd?.adDetailId)"
                  >
                    {{ $t('lbl_EMPBE_CompanyInfoCenter').trim() }}
                  </a>
                </router-link>{{ $t('lbl_EMPBE_CompanyInfoCenterHintLogo') }}
              </span>
            </div>
          </div>
        </div>

        <div
          v-if="host.getRecordLocations(group.primaryAd).length"
          class="adDetailCardWrapper_Location Ad-Top"
        >
          <div class="adDetailCardWrapper_Location_Title">{{ $t("lbl_EMPBE_AdLocatePage") }}</div>
          <div
            v-for="(loc, li) in host.getRecordLocations(group.primaryAd)"
            :key="li"
            class="adDetailCardWrapper_Location_Item"
          >
            <i class="fa fa-circle adDisplayDot"></i>
            <span>{{ loc.text }}</span>
          </div>
        </div>

        <template v-if="group.pcAd && group.pcAd.isUpload">
          <div class="Ad-Top AdUpload-Text">{{ $t("lbl_EMPBE_advertisingInfo_UploadTitle_PC") }}</div>
          <media-uploader
            v-if="detailLayout"
            :ref="'upload_' + group.pcAd.adDetailId"
            :componentId="'upload_' + group.pcAd.adDetailId"
            :MediaArray="host.getUploadedFilesRef(group.pcAd)"
            :limit="1"
            :aspectRatioStr="host.getUploadAspect(group.pcAd)"
            :galleryItemStyle="host.getUploadGalleryStyle(group.pcAd)"
            :isRequired="!host.GetPowerStrus"
            :coverPlaceholder="$t('lbl_EMPBE_advertisingInfo_ExhibitorListUploadText')"
            :fileUsageType="host.getUploadUsageType(group.pcAd)"
            filePathEndpoint="Image"
            @update="(commands, pendingFiles, imageBtns) => host.updateUploadMedia(group.pcAd, commands, pendingFiles, imageBtns)"
          />
          <AdSlotPreviewRow v-else :url="nonBannerSlotPreviewUrl">
            <media-uploader
              :ref="'upload_' + group.pcAd.adDetailId"
              :componentId="'upload_' + group.pcAd.adDetailId"
              :MediaArray="host.getUploadedFilesRef(group.pcAd)"
              :limit="1"
              :aspectRatioStr="host.getUploadAspect(group.pcAd)"
              :galleryItemStyle="host.getUploadGalleryStyle(group.pcAd)"
              :isRequired="!host.GetPowerStrus"
              :coverPlaceholder="$t('lbl_EMPBE_advertisingInfo_ExhibitorListUploadText')"
              :fileUsageType="host.getUploadUsageType(group.pcAd)"
              filePathEndpoint="Image"
              @update="(commands, pendingFiles, imageBtns) => host.updateUploadMedia(group.pcAd, commands, pendingFiles, imageBtns)"
            />
          </AdSlotPreviewRow>
          <AdSearchItemApprovalResults
            :ad="group.pcAd"
            :status-code="groupApprovalStatusCode"
            result-key-prefix="pc"
          />
        </template>
        <template v-if="group.mobileAd && group.mobileAd.isUpload">
          <div class="Ad-Top AdUpload-Text">{{ $t("lbl_EMPBE_advertisingInfo_UploadTitle_Mb") }}</div>
          <media-uploader
            v-if="detailLayout"
            :ref="'upload_' + group.mobileAd.adDetailId"
            :componentId="'upload_' + group.mobileAd.adDetailId"
            :MediaArray="host.getUploadedFilesRef(group.mobileAd)"
            :limit="1"
            :aspectRatioStr="host.getMobileUploadAspect(group.mobileAd)"
            :galleryItemStyle="host.getMobileUploadGalleryStyle(group.mobileAd)"
            :isRequired="!host.GetPowerStrus"
            :coverPlaceholder="$t('lbl_EMPBE_advertisingInfo_ExhibitorListUploadText')"
            :fileUsageType="host.getUploadUsageType(group.mobileAd)"
            filePathEndpoint="Image"
            @update="(commands, pendingFiles, imageBtns) => host.updateUploadMedia(group.mobileAd, commands, pendingFiles, imageBtns)"
          />
          <AdSlotPreviewRow v-else :url="nonBannerSlotPreviewUrl">
            <media-uploader
              :ref="'upload_' + group.mobileAd.adDetailId"
              :componentId="'upload_' + group.mobileAd.adDetailId"
              :MediaArray="host.getUploadedFilesRef(group.mobileAd)"
              :limit="1"
              :aspectRatioStr="host.getMobileUploadAspect(group.mobileAd)"
              :galleryItemStyle="host.getMobileUploadGalleryStyle(group.mobileAd)"
              :isRequired="!host.GetPowerStrus"
              :coverPlaceholder="$t('lbl_EMPBE_advertisingInfo_ExhibitorListUploadText')"
              :fileUsageType="host.getUploadUsageType(group.mobileAd)"
              filePathEndpoint="Image"
              @update="(commands, pendingFiles, imageBtns) => host.updateUploadMedia(group.mobileAd, commands, pendingFiles, imageBtns)"
            />
          </AdSlotPreviewRow>
          <AdSearchItemApprovalResults
            :ad="group.mobileAd"
            :status-code="groupApprovalStatusCode"
            result-key-prefix="mobile"
          />
        </template>
        <template v-if="!group.pcAd && !group.mobileAd && group.primaryAd.isUpload">
          <div class="Ad-Top AdUpload-Text">{{ $t("lbl_EMPBE_advertisingInfo_UploadTitle_PC") }}</div>
          <media-uploader
            v-if="detailLayout"
            :ref="'upload_' + group.primaryAd.adDetailId"
            :componentId="'upload_' + group.primaryAd.adDetailId"
            :MediaArray="host.getUploadedFilesRef(group.primaryAd)"
            :limit="1"
            :aspectRatioStr="host.getUploadAspect(group.primaryAd)"
            :galleryItemStyle="host.getUploadGalleryStyle(group.primaryAd)"
            :isRequired="!host.GetPowerStrus"
            :coverPlaceholder="$t('lbl_EMPBE_advertisingInfo_ExhibitorListUploadText')"
            :fileUsageType="host.getUploadUsageType(group.primaryAd)"
            filePathEndpoint="Image"
            @update="(commands, pendingFiles, imageBtns) => host.updateUploadMedia(group.primaryAd, commands, pendingFiles, imageBtns)"
          />
          <AdSlotPreviewRow v-else :url="nonBannerSlotPreviewUrl">
            <media-uploader
              :ref="'upload_' + group.primaryAd.adDetailId"
              :componentId="'upload_' + group.primaryAd.adDetailId"
              :MediaArray="host.getUploadedFilesRef(group.primaryAd)"
              :limit="1"
              :aspectRatioStr="host.getUploadAspect(group.primaryAd)"
              :galleryItemStyle="host.getUploadGalleryStyle(group.primaryAd)"
              :isRequired="!host.GetPowerStrus"
              :coverPlaceholder="$t('lbl_EMPBE_advertisingInfo_ExhibitorListUploadText')"
              :fileUsageType="host.getUploadUsageType(group.primaryAd)"
              filePathEndpoint="Image"
              @update="(commands, pendingFiles, imageBtns) => host.updateUploadMedia(group.primaryAd, commands, pendingFiles, imageBtns)"
            />
          </AdSlotPreviewRow>
          <AdSearchItemApprovalResults
            :ad="group.primaryAd"
            :status-code="groupApprovalStatusCode"
            result-key-prefix="primary"
          />
        </template>
      </div>
      <div class="adPreviewSection" :class="{ 'adPreviewSection--detail': detailLayout }">
        <div v-if="detailLayout" class="ad-preview-panel-meta">
          {{ $t("lbl_EMPBE_AdList_LastSubmitted") }}: {{ formatDetailDateTime(groupLastSubmitDate) }}
        </div>
        <div
          class="adPreviewCardWrapper"
          :class="{ 'adPreviewCardWrapper--detail': detailLayout }"
          :style="host.getPreviewWrapperStyle(tab.type)"
        >
          <div v-if="detailLayout" class="ad-preview-panel-header">
            <div class="ad-preview-panel-heading">
              <span class="ad-preview-panel-title">{{ $t("lbl_EMPBE_AdDetail_AdPreview") }}</span>
              <span
                v-if="showBilingualTip"
                class="ad-preview-bilingual badge-wrap"
                :aria-describedby="`tips-bilingual-${group.groupKey}`"
              >
                <span class="ad-preview-bilingual__badge">{{ $t("Bilingual") }}</span>
                <div
                  :id="`tips-bilingual-${group.groupKey}`"
                  class="tips-pop"
                  role="tooltip"
                  aria-live="polite"
                >
                  <div class="tips-box">
                    <i class="tips-arrow" aria-hidden="true"></i>
                    <h4 class="tips-title">{{ $t("BilingualTip") }}</h4>
                  </div>
                </div>
              </span>
            </div>
            <b-button
              v-b-toggle="host.getPreviewPopupId(group.primaryAd)"
              class="privewBtn"
              :t_label="host.adInfoCenterTLabel('Detail', 'btnPreviewPlacement', group.subType, group.primaryAd?.adDetailId)"
            >
              <span>{{ $t("lbl_EMPBE_advertisingInfo_PrivewButtom") }}</span>
            </b-button>
          </div>
          <Privew
            :key="`privew_${group.groupKey}`"
            :compact-header="detailLayout"
            :AdType="tab.type"
            :LocationIndex="host.getLogoLocationIndex(group.primaryAd)"
            :PcUrl="group.pcAd ? host.getRecordImageSrc(group.pcAd) : ''"
            :MbUrl="group.mobileAd ? host.getRecordImageSrc(group.mobileAd) : ''"
            :IsCpsEMarketplace="host.isEmpMarketplaceBanner(group.primaryAd)"
            :productId="tab.type === 'logoAd' ? 0 : host.getPreviewProductId(group.primaryAd)"
            :companyId="host.companyid"
            @GetComapnyInfoMsg="host.onCompanyInfoMsg"
          >
            <b-button
              v-if="!detailLayout"
              v-b-toggle="host.getPreviewPopupId(group.primaryAd)"
              class="privewBtn"
              :t_label="host.adInfoCenterTLabel('Category', 'btnPreviewPlacement', group.subType, group.primaryAd?.adDetailId)"
            >
              <i class="fa fa-eye"></i>
              <span>{{ $t('lbl_EMPBE_advertisingInfo_PrivewButtom') }}</span>
            </b-button>
          </Privew>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Privew from './Privew.vue';
import adEffectiveDateComponentNews from './adEffectiveDateComponentNews.vue';
import adDisplayPageComponentNews from './adDisplayPageComponentNews.vue';
import mediaUploader from '../../components/form/upload/imgUploader/mediaUploader.vue';
import AdSearchItemApprovalResults from './AdSearchItemApprovalResults.vue';
import AdSlotPreviewRow from './AdSlotPreviewRow.vue';
import { adService } from '../../_services/ad';

export default {
  name: 'AdRecordGroupPanel',
  components: {
    Privew,
    adEffectiveDateComponentNews,
    adDisplayPageComponentNews,
    mediaUploader,
    AdSearchItemApprovalResults,
    AdSlotPreviewRow,
  },
  inject: ['adGroupHost'],
  props: {
    group: { type: Object, required: true },
    tab: { type: Object, required: true },
    detailLayout: { type: Boolean, default: false },
  },
  computed: {
    host() {
      return this.adGroupHost;
    },
    slotPreviewUrl() {
      return this.host?.getDisplayPreviewUrl(this.group?.primaryAd) || '';
    },
    nonBannerSlotPreviewUrl() {
      return this.tab?.type !== 'bannerAd' ? this.slotPreviewUrl : '';
    },
    groupLastSubmitDate() {
      return adService.getAdGroupLastSubmitDate(this.group);
    },
    /**
     * 成对广告 ApprovalHeader 只写在 PC；组级状态优先取 PC / 任一条 R，再回落 tab.ApprovalInfo。
     */
    groupApprovalStatusCode() {
      const records = [this.group?.pcAd, this.group?.mobileAd, this.group?.primaryAd].filter(Boolean);
      const pick = (ad) => String(ad?.statusCode || ad?.StatusCode || '').trim();
      if (records.some((ad) => pick(ad) === 'R')) return 'R';
      const pcCode = pick(this.group?.pcAd || this.group?.primaryAd);
      if (pcCode) return pcCode;
      return String(this.tab?.ApprovalInfo?.statusCode || '').trim();
    },
    showBilingualTip() {
      return this.tab?.type === "landingAd";
    },
    /** 参展商名单 logo 卡片（LocationIndex=1）预览较宽，需整块预览区底部横向滚动 */
    isLogoExhibitorWidePreview() {
      if (!this.detailLayout || this.tab?.type !== "logoAd") return false;
      return this.host?.getLogoLocationIndex(this.group?.primaryAd) === 1;
    },
  },
  methods: {
    formatDetailDateTime(raw) {
      if (!raw || raw === "-" || String(raw).startsWith("0001-01-01")) return "—";
      // 详情页「最后提交」只展示到分钟，不展示秒
      return String(raw).trim().replace("T", " ").replace(/\.\d+$/, "").replace(/:\d{2}$/, "");
    },
  },
};
</script>

<style lang="scss" scoped>
.adPreviewSection {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.adPreviewSection--detail {
  gap: 16px;
  flex: 1 1 auto;
  min-width: 0;
  /* 高度 hug：不随左侧配置区 stretch */
  align-self: flex-start;
  height: fit-content;
}

.ad-record-group-panel {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.ad-preview-panel-head {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.ad-preview-panel-meta {
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.6);
  white-space: nowrap;
}

.ad-preview-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
}

.ad-preview-panel-heading {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.ad-preview-panel-title {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.8);
}

.ad-preview-bilingual {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: default;
}

.ad-preview-bilingual__badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.8);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
}

.ad-preview-bilingual .tips-pop {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  transform: translateY(-2px);
  opacity: 0;
  pointer-events: none;
  z-index: 3000;
  transition: opacity 0.12s ease, transform 0.12s ease;
}

.ad-preview-bilingual:hover .tips-pop {
  opacity: 1;
  transform: translateY(0);
}

.ad-preview-bilingual .tips-box {
  position: relative;
  max-width: 460px;
  min-width: 280px;
  padding: 10px 14px;
  border-radius: 8px;
  background: linear-gradient(180deg, #6b50f0 0%, #5a46e6 100%);
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
  font-size: 13px;
  line-height: 19px;
  font-weight: 600;
  text-align: left;
  white-space: normal;
  word-break: break-word;
}

.ad-preview-bilingual .tips-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: #fff;
}

.ad-preview-bilingual .tips-arrow {
  position: absolute;
  top: -6px;
  left: 24px;
  width: 12px;
  height: 12px;
  background: #6b50f0;
  transform: rotate(45deg);
  border-radius: 2px;
}

@media (max-width: 992px) {
  .ad-preview-panel-meta {
    white-space: normal;
    justify-content: flex-start;
  }

  .ad-preview-panel-header {
    flex-wrap: wrap;
    align-items: flex-start;
  }
}

.AdlogoTop {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 16px;
  padding: 12px;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 16px;
}

.AdlogoTop-Msg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  flex: 1 1 auto;
}

.logoImg {
  flex-shrink: 0;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
}

.Ad-logoImg {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 50%;
}

/* 详情页：选项块 / 所在页面列表 保证内边距，与上方选项块 gap 16px */
.adDetailCardWrapper_Location,
.adDetailCardWrapper_Search {
  padding: 16px;
  box-sizing: border-box;
}

.adDetailCardWrapper_Location {
  margin-top: 16px;
}

.ad-record-group-panel {
  ::v-deep .AdBlock {
    padding: 16px;
    box-sizing: border-box;

    > .row,
    .AdBlockTitle_Cat_Level > .row {
      margin-left: 0;
      margin-right: 0;
    }
  }

  ::v-deep .adDetailCardWrapper_Location {
    margin-top: 16px;
    padding: 16px;
    box-sizing: border-box;
  }
}
</style>
